import { render, staticRenderFns } from "./AppShell.vue?vue&type=template&id=202c872b&scoped=true"
import script from "./AppShell.vue?vue&type=script&lang=js"
export * from "./AppShell.vue?vue&type=script&lang=js"
import style0 from "./AppShell.vue?vue&type=style&index=0&id=202c872b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202c872b",
  null
  
)

export default component.exports